import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ActionService {
  scrollToTop$: Subject<void> = new Subject();
}
